import React from "react";
import { motion } from "framer-motion";
import { ABOUT } from "./aboData";
import AboLayout, { INK, TEAL, LIGHT, SLATE } from "./AboLayout";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function AboAbout() {
  return (
    <AboLayout active="about">
      <section className="py-16 sm:py-20" style={{ background: INK }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: "#5EEAD4" }}>About the Firm</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 text-3xl sm:text-5xl font-extrabold text-white">Resourceful, Not Just Large</motion.h1>
        </div>
      </section>

      <section className="py-16" style={{ background: LIGHT }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 space-y-6">
          <motion.div {...fadeUp} className="bg-white rounded-lg p-6 shadow-sm">
            <h3 className="font-bold text-sm uppercase tracking-wide" style={{ color: TEAL }}>Founded 2018</h3>
            <p className="mt-2 text-sm" style={{ color: SLATE }}>{ABOUT.founded} in Bonifacio Global City. {ABOUT.size}</p>
          </motion.div>
          <motion.div {...fadeUp} className="bg-white rounded-lg p-6 shadow-sm">
            <h3 className="font-bold text-sm uppercase tracking-wide" style={{ color: TEAL }}>International Network</h3>
            <p className="mt-2 text-sm" style={{ color: SLATE }}>{ABOUT.affiliation}</p>
          </motion.div>
          <motion.div {...fadeUp} className="bg-white rounded-lg p-6 shadow-sm">
            <h3 className="font-bold text-sm uppercase tracking-wide" style={{ color: TEAL }}>Our Approach</h3>
            <p className="mt-2 text-sm" style={{ color: SLATE }}>{ABOUT.positioning}</p>
          </motion.div>
        </div>
      </section>

      {/* RECOGNITION — award/press badges as displayed on the firm's own materials; not independently
          verified by MySiteCare, per the dossier's caution that self-presented awards need confirmation. */}
      <section className="py-16" style={{ background: "white" }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.h3 {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: TEAL }}>Recognition</motion.h3>
          <motion.div {...fadeUp} className="mt-8 flex flex-wrap items-center justify-center gap-6">
            <img src="/law/abo-penaranda-law-bgc-concept/award-alb-2023.png" alt="ALB Philippine Law Awards 2023 Winner, as displayed on the firm's own materials" className="h-20 w-20 object-contain" />
            <img src="/law/abo-penaranda-law-bgc-concept/award-alb-2022.png" alt="ALB Philippine Law Awards 2022 Finalist, as displayed on the firm's own materials" className="h-20 w-20 object-contain" />
            <img src="/law/abo-penaranda-law-bgc-concept/award-alb-2020.png" alt="ALB Philippine Law Awards 2020 Finalist, as displayed on the firm's own materials" className="h-20 w-20 object-contain" />
            <img src="/law/abo-penaranda-law-bgc-concept/award-sea-2020.png" alt="South East Asia Business Awards 2020, Best Multidisciplinary Law Firm — Philippines, as displayed on the firm's own materials" className="h-20 w-20 object-contain" />
          </motion.div>
          <motion.p {...fadeUp} className="mt-6 text-xs" style={{ color: SLATE }}>These recognitions are shown as the firm presents them on its own site and materials; MySiteCare has not independently verified them.</motion.p>
        </div>
      </section>
    </AboLayout>
  );
}
